module.exports = __webpack_public_path__ + "img/img_nav_bet-w.1a7da1fa.svg";